var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLocationLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 51.5789,
    height: 51.5789,
    rx: 17.193,
    fill: "#316FF6"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M38.75 23.1666C38.75 33.0833 26 41.5833 26 41.5833C26 41.5833 13.25 33.0833 13.25 23.1666C13.25 19.7851 14.5933 16.5421 16.9844 14.151C19.3755 11.7599 22.6185 10.4166 26 10.4166C29.3815 10.4166 32.6245 11.7599 35.0156 14.151C37.4067 16.5421 38.75 19.7851 38.75 23.1666Z",
    fill: "white",
    stroke: "white",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M26 27.4166C28.3472 27.4166 30.25 25.5138 30.25 23.1666C30.25 20.8194 28.3472 18.9166 26 18.9166C23.6528 18.9166 21.75 20.8194 21.75 23.1666C21.75 25.5138 23.6528 27.4166 26 27.4166Z",
    fill: "#316FF6",
    stroke: "#316FF6",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocationLogo);
export default __webpack_public_path__ + "static/media/location_logo.010c1cabfcce4880620c067168285432.svg";
export { ForwardRef as ReactComponent };